import { render, staticRenderFns } from "./Platphom.vue?vue&type=template&id=52ed29ab&scoped=true"
import script from "./Platphom.vue?vue&type=script&lang=js"
export * from "./Platphom.vue?vue&type=script&lang=js"
import style0 from "./Platphom.vue?vue&type=style&index=0&id=52ed29ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed29ab",
  null
  
)

export default component.exports